import React from 'react';
import {BusinessLayout} from 'components/layouts/business';
import {ItemPayment} from './sub-view/payment';
import style from './style.scss';
import {connect} from 'react-redux';
import {LoadingPage} from 'components/loading-page';
import {ShowIf} from 'components/utils';
import {Businesses} from 'api';
import LaddaButton, {XL, EXPAND_LEFT} from 'react-ladda';
import {toastr} from 'react-redux-toastr';
import clone from 'lodash/clone';
import {storeBusinessInfo} from 'actions';

class MyBusinessPayments extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isSubmit: false,
      data: []
    };
    this.createBlockPaymentInfo = this.createBlockPaymentInfo.bind(this);
    this.updateBlockPaymentInfo = this.updateBlockPaymentInfo.bind(this);
    this.saveBlockPaymentInfo = this.saveBlockPaymentInfo.bind(this);
  }

  componentDidMount() {
    if (this.props.mainBusiness && this.props.mainBusiness.paymentInfo) {
      this.setState({data: this.props.mainBusiness.paymentInfo});
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.mainBusiness && nextProps.mainBusiness.paymentInfo) {
      this.setState({data: nextProps.mainBusiness.paymentInfo});
    }
  }

  createBlockPaymentInfo() {
    let payments = this.state.data;
    payments.push({title: '', content: ''});
    this.setState({data: payments});
  }

  removeBlockPaymentInfo(idx) {
    let payments = this.state.data;
    payments[idx].isDelete = true;
    if (payments.length === 0 && this.props.mainBusiness.paymentInfo.length > 0) {
      let params = {
        id: this.props.mainBusiness.id,
        data: {
          paymentInfo: []
        }
      };
      Businesses.actions.update.request({id: params.id}, {data: params.data}).then((response) => {
        let myBusinesses = clone(this.props.myBusinesses);
        myBusinesses.mainBusiness = response.data;
        this.dispatch(storeBusinessInfo(myBusinesses));
      });
    }
    this.setState({data: payments});
  }

  updateBlockPaymentInfo(data, idx) {
    let payments = this.state.data;
    payments[idx].title = data.title;
    payments[idx].content = data.content;
    this.setState({data: payments});
  }

  saveBlockPaymentInfo() {
    this.setState({isSubmit: true});
    let params = {
      id: this.props.mainBusiness.id,
      data: {
        paymentInfo: this.getPayments()
      }
    };
    Businesses.actions.update.request({id: params.id}, {data: params.data}).then((response) => {
      toastr.success("Thông tin thanh toán đã được cập nhật thành công");
      let myBusinesses = clone(this.props.myBusinesses);
      myBusinesses.mainBusiness = response.data;
      this.dispatch(storeBusinessInfo(myBusinesses));
      this.setState({isSubmit: false});
    }).catch(() => {
      this.setState({isSubmit: false});
    });
  }

  getPayments() {
    let payments = [];
    this.state.data.map((payment, idx) => {
      if (!payment.isDelete) {
        payments.push({
          title: payment.title,
          content: payment.content
        });
      }
    });
    return payments;
  }

  render() {
    const {isSubmit} = this.state;
    return (
      <BusinessLayout active="payments">
        <div className="business-payment">
          <h2 className="business-payment-title">Thông tin thanh toán</h2>
          <div className="business-payment-wrap-item">
            {
              this.state.data.map((payment, idx) => {
                if (!payment.isDelete) {
                  return (
                    <ItemPayment disabled={isSubmit} updateItem={this.updateBlockPaymentInfo} removeItem={this.removeBlockPaymentInfo.bind(this, idx)} key={idx} keyItem={idx} {...payment}/>
                  );
                }
              })
            }
            <div className="business-payment-btn-add-item-wrap">
              <button type="button" disabled={isSubmit} onClick={this.createBlockPaymentInfo} className="btn-add-item-payment">Thêm khối thông tin thanh toán</button>
            </div>
          </div>
          <ShowIf condition={this.state.data.length > 0}>
            <div className="wrap-btn-update-payment">
              <LaddaButton className="btn-update-payment" onClick={this.saveBlockPaymentInfo} type="button" data-size={XL} data-style={EXPAND_LEFT} loading={isSubmit}>Cập nhật thông tin</LaddaButton>
            </div>
          </ShowIf>
        </div>
      </BusinessLayout>
    );
  }
}

const mapStateToProps = state => {
  return {
    myBusinesses: state.myBusinesses,
    mainBusiness: state.myBusinesses.mainBusiness
  };
};

export default connect(mapStateToProps)(MyBusinessPayments);



// WEBPACK FOOTER //
// ./components/my-business/MyBusinessPayments.jsx